module.exports = __webpack_public_path__ + "Concierge_Robot.a6e66e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/portal_icons/Concierge_Robot.png
// module id = 414
// module chunks = 0